/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import UpdateSettingsModule from "../../../modules/Admin/Settings/UpdateSettingsModule";
import DashboardLayout from "../../../layouts/dashboardLayout";

import { titlePage } from "../../../helpers/titleHead";

const ChangeDetailPmPage = (props) => {
  useEffect(() => {
    titlePage({
      title: "IRIS - Ubah Informasi Akun",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardLayout title="Pengaturan">
      <UpdateSettingsModule />
    </DashboardLayout>
  );
};

export default ChangeDetailPmPage;
